import axios from "./index";

export const getDashboardRequest = async () => {
  return await axios.get(`/admin/get-dashboard`);
};
